import { SetValueConfig } from 'react-hook-form';

export const constructValueConfig = (option: boolean): SetValueConfig => {
	return {
		shouldDirty: option,
		shouldValidate: option,
		shouldTouch: option,
	};
};
